import { useState } from 'react';
import { Box, Typography, Alert, AlertTitle } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import SaveIcon from '@mui/icons-material/Save';
import { FormRender } from './formRender';

const SurveyRender = () => {
    const [save, setSave] = useState<boolean>(false);
    const [survey, setSurvey] = useState<any>(undefined);
    const [isCompleted, setIsCompleted] = useState<boolean>(false);

    return !save ? (
        <Box px={{ xs: '20px', lg: 0 }}>
            <Typography
                fontFamily="Lucida Sans"
                fontSize="2rem"
                fontWeight="700!important"
                textAlign="center"
                color="#4b4b4b"
                mt={4}
            >
                {survey?.title || ''}
            </Typography>
            <FormRender
                onChangeSurvey={(survey) => setSurvey(survey)}
                onSave={(completed?: boolean) => {
                    setSave(true);
                    setIsCompleted(completed || false);
                }}
            />
        </Box>
    ) : (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: '60vh',
                p: 4,
            }}
        >
            <Alert
                severity={isCompleted ? 'success' : 'info'}
                iconMapping={{
                    success: (
                        <CheckCircleOutlineIcon
                            sx={{
                                fontSize: '4rem',
                                marginBottom: 2,
                            }}
                        />
                    ),
                    info: (
                        <SaveIcon
                            sx={{
                                fontSize: '4rem',
                                marginBottom: 2,
                            }}
                        />
                    ),
                }}
                sx={{
                    backgroundColor: 'transparent',
                    color: isCompleted ? '#2e7d32' : '#1976d2',
                    textAlign: 'center',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    maxWidth: '800px',
                    '& .MuiAlert-icon': {
                        margin: 0,
                        padding: 0,
                    },
                }}
            >
                <AlertTitle
                    sx={{
                        fontSize: '2.5rem',
                        fontWeight: 700,
                        marginBottom: 2,
                        fontFamily: 'Lucida Sans',
                    }}
                >
                    {isCompleted
                        ? '¡Gracias por completar la encuesta!'
                        : '¡Respuestas Guardadas!'}
                </AlertTitle>

                <Typography
                    sx={{
                        fontSize: '1.8rem',
                        fontWeight: 500,
                        fontFamily: 'Lucida Sans',
                        lineHeight: 1.8,
                    }}
                >
                    {isCompleted
                        ? 'Tu respuesta ha sido registrada exitosamente.'
                        : 'Tus respuestas han sido guardadas como incompletas. Puedes continuar más tarde.'}
                </Typography>
            </Alert>
        </Box>
    );
};

export default SurveyRender;
